import { Box, Button, CardMedia, Paper, Typography } from '@mui/material';
import { useRouter } from 'next/router';
// Hooks
import { useWebiny } from '@/providers/WebinyProvider';
// Utils
import { routes } from '@/routes/routes';

export default function NoWalletCard(): JSX.Element {
  const router = useRouter();
  const { setupWalletHero } = useWebiny();

  return (
    <Paper
      elevation={2}
      sx={{
        display: 'flex',
        gap: '24px',
        marginBottom: '24px',
        marginTop: '24px',
        justifyContent: 'space-between',
        '@media (max-width: 950px)': {
          flexDirection: 'column-reverse',
          justifyContent: 'center',
          alignItems: 'center',
        },
      }}
    >
      <Box>
        <Box sx={{ marginBottom: '16px' }}>
          <Typography variant="h3">{setupWalletHero.title}</Typography>
        </Box>
        <Box sx={{ marginBottom: '16px' }}>
          <Typography variant="h4">{setupWalletHero.subTitle}</Typography>
        </Box>
        <Box sx={{ marginBottom: '16px' }}>
          <Typography variant="body1">{setupWalletHero.description}</Typography>
        </Box>
        <Box sx={{ paddingTop: '16px' }}>
          <Button
            data-core-qa="setupWalletButton"
            variant="contained"
            onClick={() => {
              router.push(routes.setupWallet.path);
            }}
          >
            {setupWalletHero.button.title}
          </Button>
        </Box>
      </Box>
      <CardMedia
        component="img"
        alt="Setup Wallet"
        image={setupWalletHero.image}
        sx={{
          width: '100%',
          height: '100%',
          maxWidth: '300px',
          '@media (max-width: 950px)': {
            maxWidth: '500px',
          },
        }}
      />
    </Paper>
  );
}
